var _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgThreeDots = function SvgThreeDots(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "#fff",
    viewBox: "0 0 120 30"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#3c60ff"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    begin: "0s",
    calcMode: "linear",
    dur: "0.8s",
    from: 15,
    repeatCount: "indefinite",
    to: 15,
    values: "15;9;15"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    begin: "0s",
    calcMode: "linear",
    dur: "0.8s",
    from: 1,
    repeatCount: "indefinite",
    to: 1,
    values: "1;.5;1"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 15,
    r: 9,
    fill: "#3c60ff",
    fillOpacity: 0.3
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    begin: "0s",
    calcMode: "linear",
    dur: "0.8s",
    from: 9,
    repeatCount: "indefinite",
    to: 9,
    values: "9;15;9"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    begin: "0s",
    calcMode: "linear",
    dur: "0.8s",
    from: 0.5,
    repeatCount: "indefinite",
    to: 0.5,
    values: ".5;1;.5"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 105,
    cy: 15,
    r: 15,
    fill: "#3c60ff"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    begin: "0s",
    calcMode: "linear",
    dur: "0.8s",
    from: 15,
    repeatCount: "indefinite",
    to: 15,
    values: "15;9;15"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    begin: "0s",
    calcMode: "linear",
    dur: "0.8s",
    from: 1,
    repeatCount: "indefinite",
    to: 1,
    values: "1;.5;1"
  }))));
};
export { SvgThreeDots as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIxMCIgZmlsbD0iI2ZmZiIgdmlld0JveD0iMCAwIDEyMCAzMCI+DQogICAgPGNpcmNsZSBjeD0iMTUiIGN5PSIxNSIgcj0iMTUiIGZpbGw9IiMzYzYwZmYiPg0KICAgICAgICA8YW5pbWF0ZSBhdHRyaWJ1dGVOYW1lPSJyIiBiZWdpbj0iMHMiIGNhbGNNb2RlPSJsaW5lYXIiIGR1cj0iMC44cyIgZnJvbT0iMTUiIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIiB0bz0iMTUiDQogICAgICAgICAgICAgICAgIHZhbHVlcz0iMTU7OTsxNSIvPg0KICAgICAgICA8YW5pbWF0ZSBhdHRyaWJ1dGVOYW1lPSJmaWxsLW9wYWNpdHkiIGJlZ2luPSIwcyIgY2FsY01vZGU9ImxpbmVhciIgZHVyPSIwLjhzIiBmcm9tPSIxIiByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSINCiAgICAgICAgICAgICAgICAgdG89IjEiIHZhbHVlcz0iMTsuNTsxIi8+DQogICAgPC9jaXJjbGU+DQogICAgPGNpcmNsZSBjeD0iNjAiIGN5PSIxNSIgcj0iOSIgZmlsbD0iIzNjNjBmZiIgZmlsbC1vcGFjaXR5PSIuMyI+DQogICAgICAgIDxhbmltYXRlIGF0dHJpYnV0ZU5hbWU9InIiIGJlZ2luPSIwcyIgY2FsY01vZGU9ImxpbmVhciIgZHVyPSIwLjhzIiBmcm9tPSI5IiByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSIgdG89IjkiDQogICAgICAgICAgICAgICAgIHZhbHVlcz0iOTsxNTs5Ii8+DQogICAgICAgIDxhbmltYXRlIGF0dHJpYnV0ZU5hbWU9ImZpbGwtb3BhY2l0eSIgYmVnaW49IjBzIiBjYWxjTW9kZT0ibGluZWFyIiBkdXI9IjAuOHMiIGZyb209Ii41IiByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSINCiAgICAgICAgICAgICAgICAgdG89Ii41IiB2YWx1ZXM9Ii41OzE7LjUiLz4NCiAgICA8L2NpcmNsZT4NCiAgICA8Y2lyY2xlIGN4PSIxMDUiIGN5PSIxNSIgcj0iMTUiIGZpbGw9IiMzYzYwZmYiPg0KICAgICAgICA8YW5pbWF0ZSBhdHRyaWJ1dGVOYW1lPSJyIiBiZWdpbj0iMHMiIGNhbGNNb2RlPSJsaW5lYXIiIGR1cj0iMC44cyIgZnJvbT0iMTUiIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIiB0bz0iMTUiDQogICAgICAgICAgICAgICAgIHZhbHVlcz0iMTU7OTsxNSIvPg0KICAgICAgICA8YW5pbWF0ZSBhdHRyaWJ1dGVOYW1lPSJmaWxsLW9wYWNpdHkiIGJlZ2luPSIwcyIgY2FsY01vZGU9ImxpbmVhciIgZHVyPSIwLjhzIiBmcm9tPSIxIiByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSINCiAgICAgICAgICAgICAgICAgdG89IjEiIHZhbHVlcz0iMTsuNTsxIi8+DQogICAgPC9jaXJjbGU+DQo8L3N2Zz4NCg==";